import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import TableRow from "./TableRow";


function ProductsTable({ isCustomer,products=[],selected,setSelected ,isLoading}) {
  const order = useSelector((state) => state.order);
  const invoice = useSelector((state) => state.invoice);
  const active_category = useSelector((state) => state.common.active_category);

 


  

  return (
    <>
      <div className="w-100  justify-between row">
        <div className="w-40">
          <div className="btn t-header row justify-center align-center t-center border-bg-4  bg-1">
            <span className="text-1 ">Item Code</span>
          </div>
        </div>
        <div className="w-40">
          <div className="btn t-header row justify-center align-center t-center  border-bg-4  bg-1">
            <span className="text-1 ">Barcode</span>
          </div>
        </div>
        <div className="w-100">
          <div className="btn t-header row justify-center align-center t-center  border-bg-4  bg-1">
            <span className="text-1 ">Description</span>
          </div>
        </div>
        <div className="w-30">
          <div className="btn t-header row justify-center align-center t-center  border-bg-4 bg-1">
            <span className="text-1 ">Qty</span>
          </div>
        </div>
        <div className="w-30">
          <div className="btn t-header row justify-center align-center t-center  border-bg-4 bg-1">
            <span className="text-1 ">Price</span>
          </div>
        </div>
      </div>
      {isLoading?
      <div className="row justify-center bg-1 align-center">
        <div  className="lds-ripple"><div></div><div></div></div> 
      </div>
      :null}
      <div className="product-table-scroll" style={{maxHeight:"70vh"}}>
{products.map((e,i) => {
    return (
 <TableRow e={e} index={e.id} selected={selected} setSelected={setSelected} />
             
    )
})}
</div>
 <div className="w-100  justify-between row">
        <div className="w-100">
          <div className="btn t-header row justify-center align-center t-center border-bg-4  bg-1">
            <span className="text-1 "></span>
          </div>
        </div>
        <div className="w-100">
          <div className="btn t-header row justify-center align-center t-center  border-bg-4  bg-1">
            <span className="text-1 "></span>
          </div>
        </div>
        <div className="w-100">
          <div className="btn t-header row justify-center align-center t-center  border-bg-4  bg-1">
            <span className="text-1 "></span>
          </div>
        </div>
        <div className="w-100">
          <div className="btn t-header row justify-center align-center t-center  border-bg-4 bg-1">
            <span className="text-1 "></span>
          </div>
        </div>
        <div className="w-100">
          <div className="btn t-header row justify-center align-center t-center  border-bg-4 bg-1">
            <span className="text-1 "></span>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductsTable;
